import { Class } from "../../model"

/**
 * Retourne une chaine sous la forme "<number> - <label>" si la classe existe,
 * sinon "Indéterminée".
 * @param instructionClass
 */
export function titlize(instructionClass: Class): string {
	return instructionClass
	? `${instructionClass.number} - ${instructionClass.label}`
	: "Indéterminée"
}



// WEBPACK FOOTER //
// ./src/domain/sfp/class-domain.ts